import * as React from 'react'
import get from 'lodash/get'
import NoSSR from 'react-no-ssr'
import { withRouter, SingletonRouter } from 'next/router'
import getUrl from 'lib/url'
import Loading from 'Components/loading'
import Statement from 'Components/statement'
import AD from './ad'
import Feed from './feed'
import HotNews from './hot-news'
import DongCheFen, { CarReview } from './dong-che-fen'
import TypeList from './type-list'
import TonglanAD2 from './ad/tonglan-2'
import PopularModels from './popular-models'
import PopularBrands from './popular-brands'
import FeaturedVideos, { ArticleData } from './featured-videos'
import SalesLeaderboard from './sales-leaderboard'
import ArticleLeaderboard from './article-leaderboard'
import NewRelease from '../../components/new-release'
import { HomeStoreProvider } from './context'
import { IBrands, ICarList } from './interface'
import Banner, { IBannerList } from './banner'
import FriendShipLink, { IFriendshipLinkData } from './friendship-link'
import OriginalColumn, { IOriginalColumnData } from './original-column'
import CarAtlas, { SeriesData } from './carAtlas'
import fetch from 'lib/decorated-fetch'
import Head from 'next/head'
interface IProps {
  brands: IBrands[]
  sales: ICarList[]
  newCar: ICarList[]
  banner: IBannerList[]
  hotSpot: any
  atlas: any
  todayNews: any
  featuredVideos: any
  router: SingletonRouter
  friendshipLinkData: IFriendshipLinkData[]
  originalColumnData: IOriginalColumnData[]
  carAtlasData: SeriesData[]
  panoramicCar: {
    ns_cover_url: string
    panoramic_url: string
    series_name: string
  }
  pcHotVideoList: ArticleData[]
  articleList: ArticleData[]
  dCarScoreList: CarReview[]
}

interface IInfo {
  [key: string]: boolean
}

function Home({
  brands,
  sales,
  newCar,
  banner,
  hotSpot,
  atlas,
  todayNews,
  featuredVideos,
  friendshipLinkData,
  originalColumnData,
  carAtlasData,
  panoramicCar,
  pcHotVideoList,
  articleList,
  dCarScoreList,
}: IProps) {
  /* 由顶部类型传进来的热门车型参数 */
  const [params, setParams] = React.useState('')
  return (
    <>
      <Head>
        <link rel="canonical" href="https://www.dongchedi.com" />
      </Head>
      <HomeStoreProvider>
        <div className="homepage">
          <section className="main">
            <AD />
            <TypeList />
            <div className="clearfix">
              <PopularModels params={params} setParams={setParams} />
              <PopularBrands brands={brands} />
            </div>
            {banner.length > 0 && (
              <Banner banner={banner} todayNews={todayNews} />
            )}
          </section>
          {hotSpot.length > 0 && <HotNews hotSpot={hotSpot} />}
          <OriginalColumn data={originalColumnData} />
          {dCarScoreList?.length > 0 && (
            <DongCheFen reviewData={dCarScoreList} />
          )}
          {featuredVideos.length > 0 && (
            <FeaturedVideos
              featuredVideos={featuredVideos}
              articleList={pcHotVideoList}
            />
          )}
          {carAtlasData.length > 0 && (
            <CarAtlas seriesList={carAtlasData} panoramicCar={panoramicCar} />
          )}
          <TonglanAD2 />
          <section className="clearfix content" id="home_feed">
            <div className="feed fl">
              <NoSSR onSSR={<Loading />}>
                <Feed />
              </NoSSR>
            </div>
            <div className="leaderboard fr">
              <NewRelease />
              {articleList?.length > 0 && (
                <ArticleLeaderboard article={articleList} />
              )}
              {sales?.length > 0 && <SalesLeaderboard sales={sales} />}
              <FriendShipLink />
              <Statement />
            </div>
          </section>
          <style jsx>
            {`
              .homepage {
                width: 1196px;
                margin: 0 auto 0;
              }
              .main {
                position: relative;
              }
              .content {
                padding-top: 20px;
              }
              .feed {
                width: 790px;
                min-width: 790px;
                min-height: 1px;
              }
              .leaderboard {
                width: 380px;
                margin-left: 10px;
              }
              .fr {
                float: right;
              }
            `}
          </style>
        </div>
      </HomeStoreProvider>
    </>
  )
}

Home.getInitialProps = async ({ req }: any) => {
  /* 获取品牌数据 */
  const brands = async () => {
    const json = await fetch(
      getUrl(
        `/motor/brand/m/v1/brand/?data_from=web&webid=0`,
        'motor.brand.api'
      ),
      { req }
    ).catch((err) => {
      console.error(err)
      return []
    })

    let data = json?.data || []
    if (!Array.isArray(data)) {
      data = []
    }
    return data
  }
  /* 获取销量排行榜数据 */
  const sales = async () => {
    try {
      const months = await fetch(
        getUrl('/motor/car_show/v1/sells_rank_month/', 'motor.car_show.api'),
        { req }
      )
      const month = get(months, 'data[0].month', '201902')
      const json = await fetch(
        getUrl(
          `/motor/car_show/v1/get_sells_rank/?month=${month}&rank_type=100&offset=0&limit=3`,
          'motor.car_show.api'
        ),
        { req }
      )
      let data = json?.data?.list || []
      if (!Array.isArray(data)) {
        data = []
      }
      return data
    } catch (err) {
      console.error(err)
      return []
    }
  }
  /* 获取新车发布数据 */
  const newCar = async () => {
    try {
      const json = await fetch(
        getUrl('/motor/card/new_series_head_data/v1/', 'motor.card.api'),
        {
          req,
        }
      )
      let data = json?.data?.series_list || []
      if (!Array.isArray(data)) {
        data = []
      }
      return data
    } catch (err) {
      console.error(err)
      return []
    }
  }
  /* 获取banner数据 */
  const banner = async () => {
    try {
      const json = await fetch(
        getUrl(
          '/motor/card/common_cate_head/v1/?category=tt_car_channel&device_platform=web',
          'motor.card.api'
        ),
        { req }
      )
      let data = json?.data?.list?.[0]?.info?.list || []
      if (!Array.isArray(data)) {
        data = []
      }
      return data
    } catch (err) {
      console.error(err)
      return []
    }
  }
  /* 每日热点数据 */
  const hotSpot = async () => {
    try {
      const json = await fetch(
        getUrl(
          '/motor/pleasure/top-news/top-news-index?source=pc_station',
          'motor.pleasure.api'
        ),
        { req }
      )
      let data = json?.data || []
      if (!Array.isArray(data)) {
        data = []
      }
      return data
    } catch (err) {
      console.error(err)
      return []
    }
  }
  /* 获取图集数据 */
  const atlas = async () => {
    try {
      const json = await fetch(
        getUrl(
          '/motor/car_show/v1/get_rank/?rank_type=100&offset=0&limit=5',
          'motor.car_show.api'
        ),
        { req }
      )
      let data = json?.data || []
      if (!Array.isArray(data)) {
        data = []
      }
      return data
    } catch (err) {
      console.error(err)
      return []
    }
  }
  /* 获取今日要闻数据 */
  const todayNews = async () => {
    try {
      const json = await fetch(
        getUrl('/motor/m_api/pc_recommend_articles', 'motor.m_station.api'),
        {
          req,
        }
      )
      let data = json?.data || []
      if (!Array.isArray(data)) {
        data = []
      }
      return data
    } catch (err) {
      console.error(err)
      return []
    }
  }
  /* 获取精选视频数据 */
  const featuredVideos = async () => {
    try {
      const json = await fetch(
        getUrl('/motor/pleasure/pc/selected_video', 'motor.pleasure.api'),
        {
          req,
        }
      )
      let data = json?.data || []
      if (!Array.isArray(data)) {
        data = []
      }
      return data
    } catch (err) {
      console.error(err)
      return []
    }
  }
  /* 获取友情链接数据 */
  const friendshipLinkData = async () => {
    try {
      const json = await fetch(
        getUrl('/cloud/api/invoke/get_pc_friendship_link'),
        { req }
      )
      return json || []
    } catch (err) {
      console.error(err)
      return []
    }
  }
  // PC2.0 原创节目数据
  const originalColumnData = async () => {
    const json = await fetch(
      getUrl('/motor/m_api/pc_top_columns', 'motor.m_station.api'),
      {
        req,
      }
    ).catch((err) => {
      console.error('[fetch] originalColumnData error =', err)
      return []
    })
    let data = json?.data || []
    if (!Array.isArray(data)) {
      data = []
    }
    return data
  }

  const carAtlasData = async () => {
    const json = await fetch(
      getUrl('/motor/m_api/pc_view_image', 'motor.m_station.api'),
      {
        req,
      }
    ).catch((err) => {
      console.error('[fetch] carAtlasData error', err)
      return {}
    })
    const data = json?.data || {}
    return data
  }

  const pcHotVideo = async () => {
    const json = await fetch(
      getUrl(
        `/motor/m_api/pc_hot_rank?source_from=video`,
        'motor.m_station.api'
      ),
      { req }
    ).catch((err) => {
      console.error('[fetch] pcHotVideo error', err)
      return []
    })

    let data = json?.data || []
    if (!Array.isArray(data)) {
      data = []
    }
    return data
  }

  const pcHotArticle = async () => {
    const json = await fetch(
      getUrl(
        `/motor/m_api/pc_hot_rank?source_from=article`,
        'motor.m_station.api'
      ),
      { req }
    ).catch((err) => {
      console.error('[fetch] pcHotArticle error', err)
      return []
    })

    let data = json?.data || []
    if (!Array.isArray(data)) {
      data = []
    }
    return data
  }

  const dcarScoreData = async () => {
    const json = await fetch(
      getUrl('/motor/m_api/pc_car_reviews', 'motor.m_station.api'),
      {
        req,
      }
    ).catch((error) => {
      console.error('[fetch] dCarScore error', error)
      return []
    })
    let data = json?.data || []
    if (!Array.isArray(data)) {
      data = []
    }
    return data
  }

  const data = await Promise.all([
    sales(),
    // hot(),
    newCar(),
    banner(),
    hotSpot(),
    atlas(),
    todayNews(),
    featuredVideos(),
    //friendshipLinkData(),
    Promise.resolve(),
    brands(),
    originalColumnData(),
    carAtlasData(),
    pcHotVideo(),
    pcHotArticle(),
    dcarScoreData(),
  ])
  let hotSpotData = data[3].slice(0, 14)
  const todayNewsData = data[5]
  const bannerData = data[2].slice(0, 5)

  hotSpotData = hotSpotData.filter(
    (item: { unique_id_str: string }) =>
      !/专题|话题/.test(get(item, 'info.feature_label.name', ''))
  )
  return {
    sales: data[0],
    // hot: data[2],
    newCar: data[1],
    banner: bannerData,
    hotSpot: hotSpotData,
    atlas: data[4],
    todayNews: todayNewsData,
    featuredVideos: data[6].slice(0, 15),
    friendshipLinkData: null,
    brands: data[8],
    originalColumnData: data[9],
    carAtlasData: data[10].nice_series_list || [],
    panoramicCar: data[10].panoramic_car || {},
    pcHotVideoList: data[11],
    articleList: data[12],
    dCarScoreList: data[13],
  }
}

export default withRouter<IProps>(Home)
